module.exports = __webpack_public_path__ + "static/media/bts_lalela_170705_006_small.2ba0b73a.jpg";